// Fun facts for the launch screen. The other languages pair with this list by
// index. Short (the test caps them at 20 words) and checkable; a word a fact
// teaches is written in Armenian script, since the app teaches sounds, not
// romanizations.
export const en: readonly string[] = [
	"Armenian has its own alphabet. Mesrop Mashtots created it around the year 405.",
	"Mashtots made 36 letters. Armenians added a few more later.",
	"Armenian letters were once numbers too: Ա meant 1 and Բ meant 2.",
	"The duduk is a woodwind instrument carved from apricot wood.",
	"UNESCO protects duduk music as a treasure of world culture.",
	"The apricot's scientific name, Prunus armeniaca, means “Armenian plum”.",
	"Armenia's flag has three stripes: red, blue and apricot.",
	"Lavash is a thin Armenian flatbread baked on the walls of a clay oven.",
	"Yerevan, the capital, is older than Rome. It was founded in 782 BC.",
	"From Yerevan you can see Mount Ararat, a symbol of Armenia.",
	"Lake Sevan sits high in the mountains, about 1,900 metres above the sea.",
	"In Armenian schools, chess is a school subject, like maths.",
	"Wings of Tatev is a cable car almost 6 kilometres long, over a deep gorge.",
	"Armenians call their country Հայաստան. Soon you will be able to read that!",
	"Khachkars are stone crosses carved like lace. Thousands stand all over Armenia.",
	"The world's oldest known leather shoe, about 5,500 years old, was found in an Armenian cave.",
	"On Vardavar, a summer festival, people splash water on each other.",
	"The Matenadaran in Yerevan keeps thousands of very old handwritten books.",
	"Armenia was the first country to make Christianity its official religion, in the year 301.",
	"Hello in Armenian is Բարև. Try reading it letter by letter!",
];
